import { BaseModel } from "model/BaseModel";

export default class MotivoParada implements BaseModel {
    id: number;
    codigo: string | null="";
    descricao: string;
    controlaHorario: boolean;
    desconsideraHorasNaMeta: boolean;

    constructor(
        id = 0,
        descricao = '',
        controlaHorario = false,
        desconsideraHorasNaMeta = false
    ) {
        this.id = id;
        this.descricao = descricao;
        this.controlaHorario = controlaHorario;
        this.desconsideraHorasNaMeta = desconsideraHorasNaMeta;
    }
}